import React, { useState, useContext } from 'react';
import { LegalText } from 'anf-core-react';
import ProductPageContext from '../../contexts/ProductPageContext';
import ModalPagination from '../../tools/pagination';
import StoreCardDetails from '../StoreCardDetails/StoreCardDetails';

export default function FindAStoreModalPaginationWrapper({ getStoresData }) {
  const ProductPageState = useContext(ProductPageContext);
  const { tmntData } = ProductPageState;
  const storesData = getStoresData?.stores;
  const totalStores = getStoresData?.totalStores;
  const [page, setPage] = useState(1);
  const totalPages = [];
  totalPages.length = storesData.length;
  totalPages.fill(1);

  const getPaginatedData = () => storesData.slice(page - 1, page);

  const paginatedData = () => getPaginatedData().map(
    (column) => column.map((store) => (
      <li key={store.storeNumber}>
        <div className="store-list-wrapper" data-testid="storeCardDetails-wrapper">
          <StoreCardDetails
            addressLine={store.addressLine[0]}
            city={store.city}
            stateOrProvinceName={store.stateOrProvinceName}
            postalCode={store.postalCode}
            telephone={store.telephone}
            name={store.name}
          />
        </div>
      </li>
    )),
  );

  return (
    <>
      <ul>{paginatedData()}</ul>
      {totalStores > 3 && (
        <div className="scope-1892">
          <div className="pagination-wrapper">
            <ModalPagination setPage={setPage} page={page} totalPages={totalPages} />
          </div>
        </div>
      )}
      <div className="store-list-legal-text">
        <LegalText>
          {tmntData?.productAvailLegalText?.value}
          {' '}
          {tmntData?.promotionLegalText?.value}
        </LegalText>
      </div>
    </>
  );
}
